/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class AddFamilyInformationActionsNames {
  static GetAddFamilyInformationDialogType = (): string => '[AddFamilyInformation] GetAddFamilyInformationDialogType';
  static GetAddFamilyInformationDialogTypeSuccess = (): string =>
    '[AddFamilyInformation] GetAddFamilyInformationDialogType Success';

  static SaveFamilyInformationInXml = (): string => '[AddFamilyInformation] SaveFamilyInformationInXml';
  static SaveFamilyInformationInXmlSuccess = (): string => '[AddFamilyInformation] SaveFamilyInformationInXml Success';

  static ChangeFamilyInformationDialogDimensions = (): string => '[AddFamilyInformation] ChangeDialogDimensions';
  static ChangeFamilyInformationDialogDimensionsSuccess = (): string =>
    '[AddFamilyInformation] ChangeDialogDimensions Success';

  static GetPdfLocationPath = (): string => '[AddFamilyInformation] GetPdfLocationPath';
  static GetPdfLocationPathSuccess = (): string => '[AddFamilyInformation] GetPdfLocationPath Success';

  static OpenPdfFile = (): string => '[AddFamilyInformation] OpenPdfFile';
  static OpenPdfFileSuccess = (): string => '[AddFamilyInformation] OpenPdfFile Success';

  static SendClosePopupAction = (): string => '[AddFamilyInformation] SendClosePopupAction';
  static SendClosePopupActionSuccess = (): string => '[AddFamilyInformation] SendClosePopupAction Success';

  static SaveServiceType = (): string => '[AddFamilyInformation] SaveServiceType';
  static SaveServiceTypeSuccess = (): string => '[AddFamilyInformation] SaveServiceType Success';

  static DeleteServiceType = (): string => '[AddFamilyInformation] DeleteServiceType';
  static DeleteServiceTypeSuccess = (): string => '[AddFamilyInformation] DeleteServiceType Success';

  static GetUserCustomImage = (): string => '[AddFamilyInformation] GetUserCustomImage';
  static GetUserCustomImageSuccess = (): string => '[AddFamilyInformation] GetUserCustomImage Success';

  static ValidateAndGetData = (): string => '[AddFamilyInformation] ValidateAndGetData';
  static ValidateAndGetDataSuccess = (): string => '[AddFamilyInformation] ValidateAndGetData Success';

  static ApplyDeviceEquipmentDetails = (): string => '[AddFamilyInformation] ApplyDeviceEquipmentDetails';
  static ApplyDeviceEquipmentDetailsSuccess = (): string => '[AddFamilyInformation] ApplyDeviceEquipmentDetails Success';
}
